import React, { memo } from "react"
import CSlider from "./stencil/cslider-wrapper"
import CText from "./stencil/ctext-wrapper"
import PropTypes from "prop-types"

const WeSlider = ({ children, lang = "de", dimensions, activeSlideIndex }) => {
  const content = require("../data/about.json").we[lang]

  return (
    <CSlider
      sliderClasses="about-content"
      slides={2}
      lang={lang}
      path="about"
      lastArrowBlack={true}
      collapseOnMobile={true}
      loadLastSlideItemHalfway={true}
      activeSlideIndex={activeSlideIndex}
    >
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/about/DSCF9051-01_sw_xd4zvk"
          crop="fill"
          width={dimensions[0]}
          height={
            dimensions[0] < 641
              ? Math.round(dimensions[1] * 0.5)
              : dimensions[1]
          }
        />
      </div>
      <div className="carousel-item">
        {children}
        <CText
          richText={content}
          maxDesktopText={700}
          maxMobileText={lang === "cn" ? 150 : 250}
          lang={lang}
          noArrows={dimensions[0] < 641 ? true : false}
          viewport={dimensions[0] < 641 ? "mobile" : "desktop"}
        />
      </div>
    </CSlider>
  )
}

WeSlider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
  dimensions: PropTypes.array,
  activeSlideIndex: PropTypes.number,
}

export default memo(WeSlider)
